import React from 'react';
import ColorUtils from '../utils/colors'
import { Box } from '@mui/material';

export function KeyFeature(props) {
  return (
    <Box sx={{
      textAlign: 'center',
      color: ColorUtils.textColor,
      margin: '0rem auto',
      maxWidth: '18rem',
      padding: '2rem 1.5rem',
      borderRadius: '20px',
      transition: 'all 0.3s ease',
      cursor: 'default',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 15px 35px rgba(0,0,0,0.06)',
        backgroundColor: ColorUtils.white,
      }
    }}>
      <Box sx={{
        color: props.iconColor,
        width: '4.5rem',
        height: '4.5rem',
        margin: '0rem auto 1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: props.iconColorBg,
        borderRadius: '50%',
        transition: 'all 0.3s ease',
        '& i': { fontSize: '2.2rem', display: 'block' },
        '.MuiBox-root:hover &': {
          transform: 'scale(1.1) rotate(5deg)',
          boxShadow: `0 8px 25px ${props.iconColor}40`,
        }
      }}>
        <i className={`iconfont ${props.icon}`}></i>
      </Box>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 700, margin: '0 0 0.8rem 0' }}>{props.title}</h2>
      <p style={{ lineHeight: 1.6, color: ColorUtils.textColorGrey, margin: 0 }}>{props.desc}</p>
    </Box>
  )
}

export default KeyFeature;